import { DynamicStandaloneFront } from '@/components/Front';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';

const LabradorFront: LabradorComponent = ({ type, meta, descendants, ...props }) => {
  return <DynamicStandaloneFront descendants={descendants} {...props} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorFront;
